import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/personApplications/import/page',
    method: 'get',
    params,
  })
}
export async function createData(data) {
  return request({
    url: '/personApplications/import/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/personApplications/import/update',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/personApplications/import/delete',
    method: 'post',
    data,
  })
}
export async function submit(data) {
  return request({
    url: '/personApplications/import/submit',
    method: 'post',
    data,
  })
}
